export default __webpack_public_path__ + "static/media/Weather_01.83baf38e.png";